import { render, staticRenderFns } from "./ApplyJobDetail.vue?vue&type=template&id=ce8a8eae&scoped=true&"
import script from "../../../services/applicant/apply/apply-job-detail.js?vue&type=script&lang=js&"
export * from "../../../services/applicant/apply/apply-job-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=ce8a8eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8a8eae",
  null
  
)

export default component.exports